import React, { StrictMode } from "react";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "./App/store";
import { CropImageContextProvider } from './Context/CropImageContext';
import * as Sentry from "@sentry/react";
import { RegistrationContextProvider } from "./Context/RegistrationContext";

Sentry.init({
  dsn: "https://a45ba26e866a10f5625ab36f6eca0124@o4507635431768064.ingest.de.sentry.io/4509592525537360",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration()
  ],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <StrictMode>
    <Provider store={store}>
      <CropImageContextProvider>
        <RegistrationContextProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </RegistrationContextProvider>
      </CropImageContextProvider>
    </Provider>
  </StrictMode>
);

reportWebVitals();